// create iframe map component
import React from 'react';

const Map = () => {
    return (
        <div style={{ width: '100%', height: '100%' }}>
            <iframe
                title="World Map - New Delhi"
                src="https://maps.google.com/maps?q=New%20Delhi,%20India&z=12&output=embed"
                style={{ width: '100%', height: '100%', border: '0', borderRadius: '7px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            />
        </div>
    );
};

export default Map;
